import { render, staticRenderFns } from "./SubscriptionFilters.vue?vue&type=template&id=b530b8f4&"
import script from "./SubscriptionFilters.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFilters.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports